import { Buffer } from "buffer";
import apis from "../../app/apis";
// import { AxiosError } from "axios";
import fileDownload from "js-file-download";
import { store } from "../../app/store";
import {
  IPageRequest,
  IStartupConfig,
  IPageResponse,
  IField,
  IKey,
  IDdlField,
  IOption,
  IRow,
  ILoginInformation,
} from "../../app/types";
import {
  // setStartupConfigs,
  setPageResp,
  setPageReqGlobalFunc,
  setPageReqGlobalGetOptions,
  setPageReqGlobalDdlists,
  setPageReqGlobalAction,
  setPageReqGlobalReqCode,
  setPageReqGlobalThread,
  setPageReqGlobalScreen,
  setPageReqGlobalFields,
  setPageReqFields,
  setPageReqGlobalCaller,
  setPageReqGlobalKeys,
  setPageReqKeys,
  setPageReqDdlists,
  resetClientState,
  resetPageReq,
  setRespCallStack,
} from "./clientSlice";
import { GridStateColDef } from "@mui/x-data-grid";
import {
  setAppBarLoginInfo,
  resetAppBarState,
  setStartupConfigs,
} from "../AppBar/AppBarSlice";
import {
  resetMainContentState,
  setMainContentFieldList,
  setMainContentButtonList,
  setMainContentDdlist,
  setMainContentGridList,
  setMainContentMessageList,
  setMainContentCaption,
  setMainContentScreen,
  setMainContentDialogPopUp,
} from "../MainContent/MainContentSlice";
import {
  resetSidebarState,
  setSidebarOptionsList,
} from "../Sidebar/SidebarSlice";
import { setCookie, getCookie } from "../../app/utils/cookies";
import { updateNavList } from "../MainContent/MainContentUtils";

export const downloadFileFromServer = (file: string) => {
  return new Promise<void>((resolve, reject) => {
    var state = store.getState();

    var startupConfigs: IStartupConfig = state.appBar.startupConfigs
      ? state.appBar.startupConfigs
      : ({} as IStartupConfig);

    var url =
      startupConfigs.deploymentMode === "server"
        ? file
        : startupConfigs.apiPath +
          (file.indexOf("/") === 0 ? file.slice(1) : file);

    apis
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, url.split("/")[url.split("/").length - 1]);
        resolve();
      })
      .catch((err: any) => {
        if (startupConfigs && startupConfigs.debugOn)
          console.log("Exception error: ", err);

        if (err.name === "AxiosError") {
          store.dispatch(
            setMainContentDialogPopUp({
              header: "REST API Error",
              content: {
                title: {
                  Message:
                    "The REST API did not respond timeously. Please check the HTTP server instance CGI jobs.",
                },
                details: {
                  "HTTP Instance":
                    Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                    state.appBar.loginInfo.headers["x-mdrsrvjob"]
                      ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                          "-"
                        )[2]
                      : "",
                  "CGI Job No":
                    Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                    state.appBar.loginInfo.headers["x-mdrsrvjob"]
                      ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                          "-"
                        )[3]
                      : "",
                },
                footer:
                  "RELOAD will reload the application and return you to the first screen",
              },
              action: ["RELOAD"],
            })
          );
        } else if (err.message.search(/timeout/gi) === 0)
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.message}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["WAIT", "DISMISS"],
            })
          );
        else if (err.response && err.response.request)
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.response.status} ${err.response.statusText} - ${err.response.request.responseURL}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["DISMISS"],
            })
          );
        else
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.response.status} ${err.response.statusText} - ${err.response.request.responseURL}`,
                },
                details: {
                  Recovery: "Please check the Server status or File path",
                },
              },
              action: ["DISMISS"],
            })
          );
      });

    // store.dispatch({
    //   type: "SET_AWAIT_RESPONSE",
    //   payload: false,
    // });
    // });
  });
};

export const populateQueryParamsRequest = () => {
  return new Promise((resolve, reject) => {
    var params = document.location.search
      .substr(1, document.location.search.length + 1)
      .split("&");

    var keys: IKey[] = [];

    /* Reset request params */
    store.dispatch(
      resetPageReq({
        global: {},
      } as IPageRequest)
    );

    params.forEach((param) => {
      switch (true) {
        case param.split("=")[0].search(/function/) === 0:
          /* Set function */
          store.dispatch(
            setPageReqGlobalFunc(param.split("=")[1].toUpperCase().trim())
          );
          break;

        case param.split("=")[0].search(/key/) === 0:
          /* Set keys */
          var key = {} as IKey;

          key["name"] = param
            .split("=")[0]
            .split("key")[1]
            .toUpperCase()
            .trim();
          key["value"] = param.split("=")[1];

          keys.push(key);

          break;
      }
    });

    if (keys.length) {
      store.dispatch(setPageReqGlobalKeys("true"));
      store.dispatch(setPageReqKeys(keys));
    }

    // window.location.search = "";
    window.history.pushState(
      {},
      "",
      window.location.origin + window.location.pathname
    );
    resolve(prepareAndSendPageReq());
  });
};

export const populateOptionClickRequestParams = (option: IOption) => {
  return new Promise((resolve, reject) => {
    var state = store.getState();

    /* Reset request params */
    store.dispatch(
      resetPageReq({
        global: {},
      } as IPageRequest)
    );

    if (
      option.function !== undefined &&
      option.function !== "" &&
      option.function !== "*SAME"
    ) {
      /* Set function */
      store.dispatch(setPageReqGlobalFunc(option.function));

      /* Set action */
      store.dispatch(setPageReqGlobalAction(option.action || ""));

      /* Set caller */
      store.dispatch(
        setPageReqGlobalCaller(state.client.pageResp.global.function || "")
      );
    } else {
      /* Set function */
      store.dispatch(
        setPageReqGlobalFunc(state.client.pageResp.global.function || "")
      );

      /* Set action */
      store.dispatch(
        setPageReqGlobalAction(state.client.pageResp.global.action || "")
      );

      /* Set thread */
      store.dispatch(
        setPageReqGlobalThread(state.client.pageResp.global.thread || "")
      );
    }

    /* Set request code */
    store.dispatch(setPageReqGlobalReqCode(option.name || ""));

    /* Set screen */
    store.dispatch(setPageReqGlobalScreen(state.client.pageResp.global.screen));

    resolve(prepareAndSendPageReq());
  });
};

export const populateLinkClickRequestParams = (link: any) => {
  return new Promise((resolve, reject) => {
    var state = store.getState();

    var colDef: GridStateColDef<any, any, any> & {
      clickable: string;
      keys: IKey[];
      function: string;
      action: string;
      canEdit: string;
    } = link.colDef;

    /* Reset request params */
    store.dispatch(
      resetPageReq({
        global: {},
      } as IPageRequest)
    );

    if (
      colDef.function !== undefined &&
      colDef.function !== "" &&
      colDef.function !== "*SAME"
    ) {
      /* Set function */
      store.dispatch(setPageReqGlobalFunc(colDef.function));

      /* Set action */
      store.dispatch(setPageReqGlobalAction(colDef.action || ""));

      /* Set caller */
      store.dispatch(
        setPageReqGlobalCaller(state.client.pageResp.global.function || "")
      );
    } else {
      /* Set function */
      store.dispatch(
        setPageReqGlobalFunc(state.client.pageResp.global.function || "")
      );

      /* Set action */
      store.dispatch(
        setPageReqGlobalAction(state.client.pageResp.global.action || "")
      );

      /* Set thread */
      store.dispatch(
        setPageReqGlobalThread(state.client.pageResp.global.thread || "")
      );
    }

    /* Set screen */
    // store.dispatch(setPageReqGlobalScreen(state.client.pageResp.global.screen));

    if (colDef.keys) {
      store.dispatch(setPageReqGlobalKeys("true"));

      /* Fetching values of keys from grid/maincontent fieldlist */
      var keys = JSON.parse(JSON.stringify(colDef.keys)).map((key: IKey) => {
        /* If it is a Field */
        if (key.value.split(".")[0] === "F")
          key.value =
            Object.keys(link.row).indexOf(key.name) >= 0
              ? link.row[key.name]
              : state.mainContent.fieldList.find(
                  (fld) => fld.name === key.name
                ) !== undefined
              ? state.mainContent.fieldList.find(
                  (fld) => fld.name === key.name
                )!.value
              : "";

        return {
          name: key.name,
          value: key.value,
        };
      });

      store.dispatch(setPageReqKeys(keys));
    }

    resolve(prepareAndSendPageReq());
  });
};

export const populateButtonClickRequestParams = (btn: IField) => {
  return new Promise((resolve, reject) => {
    var state = store.getState();

    /* Reset request params */
    store.dispatch(
      resetPageReq({
        global: {},
      } as IPageRequest)
    );

    if (btn.name === "WAIT")
      resolve(prepareAndSendPageReq(undefined, undefined, true));
    else {
      if (
        (btn.function === "*BACK" || btn.function === "BACK") &&
        state.client.respCallStack.length > 1 // Atleast 2 elements should be there in the call stack
      ) {
        /* Invoke BACK click procedure */
        populateBackClickRequestParams(btn.function);
      } else if (
        btn.function !== undefined &&
        btn.function !== "" &&
        btn.function !== "*SAME"
      ) {
        /* Set function */
        store.dispatch(setPageReqGlobalFunc(btn.function));

        /* Set action */
        store.dispatch(setPageReqGlobalAction(btn.action || ""));

        /* Set caller */
        store.dispatch(
          setPageReqGlobalCaller(state.client.pageResp.global.function || "")
        );
      } else {
        /* Set function */
        store.dispatch(
          setPageReqGlobalFunc(
            state.client.pageResp.global.function
              ? state.client.pageResp.global.function
              : ""
          )
        );

        /* Set action */
        store.dispatch(
          setPageReqGlobalAction(
            state.client.pageResp.global.action
              ? state.client.pageResp.global.action
              : ""
          )
        );

        /* Set thread */
        store.dispatch(
          setPageReqGlobalThread(state.client.pageResp.global.thread || "")
        );

        /* Set request code */
        store.dispatch(setPageReqGlobalReqCode(btn.name));
      }

      /* Set screen */
      // store.dispatch(setPageReqGlobalScreen(state.client.pageResp.global.screen));

      /* Set getOptions */
      store.dispatch(setPageReqGlobalGetOptions("true"));

      /* Set keys */
      if (btn.keys) {
        /* Fetching values of keys from the response/maincontent lists */
        var keys = JSON.parse(JSON.stringify(btn.keys));

        var keys = keys.map((key: IKey) => {
          /* If it is a Field */
          if (key.value.split(".")[0] === "F")
            key.value =
              state.mainContent.fieldList &&
              state.mainContent.fieldList?.find(
                (fld) => fld.name === key.name
              ) !== undefined
                ? state.mainContent.fieldList.find(
                    (fld) => fld.name === key.name
                  )!.value
                : "";

          return {
            name: key.name,
            value: key.value,
          };
        });

        store.dispatch(setPageReqGlobalKeys("true"));
        store.dispatch(setPageReqKeys(keys));
      } else if (state.mainContent.fieldList) {
        /* Set fields (if any) */
        var fields = JSON.parse(JSON.stringify(state.mainContent.fieldList));
        var filteredFields: any[] = [];

        fields
          .filter((fld: IField) => fld.grid !== undefined)
          .forEach((fld: IField) => {
            fld.rows!.forEach((fldRow: IRow) => {
              if (fldRow.isModified)
                filteredFields.push({
                  name: fld.name,
                  grid: fld.grid,
                  row: fldRow.row,
                  value: fldRow.value,
                });
            });
          });

        filteredFields = filteredFields.concat(
          fields.filter(
            (fld: IField) =>
              fld.editable &&
              fld.editable === "true" &&
              fld.isModified &&
              !fld.grid
          )
        );

        store.dispatch(setPageReqFields(filteredFields));
        store.dispatch(setPageReqGlobalFields("true"));
      }

      resolve(prepareAndSendPageReq());
    }
  });
};

export const populateBreadCrumbClickRequestParams = (name: string) => {
  return new Promise((resolve, reject) => {
    var state = store.getState();

    if (state.client.respCallStack.length > 1) {
      /* Reset request params */
      store.dispatch(
        resetPageReq({
          global: {},
        } as IPageRequest)
      );

      /* Set function */
      store.dispatch(
        setPageReqGlobalFunc(
          state.client.respCallStack[
            state.mainContent.navList.findIndex((nav) => nav.id === name)
          ].function
        )
      );

      /* Set action */
      store.dispatch(
        setPageReqGlobalAction(
          state.client.respCallStack[
            state.mainContent.navList.findIndex((nav) => nav.id === name)
          ].action
        )
      );

      /* Set thread */
      store.dispatch(
        setPageReqGlobalThread(
          state.client.respCallStack[
            state.mainContent.navList.findIndex((nav) => nav.id === name)
          ].thread
        )
      );

      /* Set getOptions */
      store.dispatch(setPageReqGlobalGetOptions("true"));

      /* Set screen */
      store.dispatch(setPageReqGlobalScreen("*NORUN"));

      /* Delete the top most entry from array */
      if (state.client.respCallStack.length > 1)
        store.dispatch(
          setRespCallStack(
            state.client.respCallStack.slice(
              0,
              state.mainContent.navList.findIndex((nav) => nav.id === name) + 1
            )
          )
        );

      resolve(prepareAndSendPageReq());
    } else {
      resolve("");
    }
  });
};

export const populateBackClickRequestParams = (name: string) => {
  return new Promise((resolve, reject) => {
    var state = store.getState();

    if (state.client.respCallStack.length > 1) {
      /* Reset request params */
      store.dispatch(
        resetPageReq({
          global: {},
        } as IPageRequest)
      );

      /* Set function */
      store.dispatch(
        setPageReqGlobalFunc(
          state.client.respCallStack[state.client.respCallStack.length - 2]
            .function
        )
      );

      /* Set action */
      store.dispatch(
        setPageReqGlobalAction(
          state.client.respCallStack[state.client.respCallStack.length - 2]
            .action
        )
      );

      /* Set thread */
      store.dispatch(
        setPageReqGlobalThread(
          state.client.respCallStack[state.client.respCallStack.length - 2]
            .thread
        )
      );

      /* Set getOptions */
      store.dispatch(setPageReqGlobalGetOptions("true"));

      /* Set screen */
      if (name === "BACK") store.dispatch(setPageReqGlobalScreen("*NORUN"));

      /* Set Request Code */
      if (name === "*BACK") store.dispatch(setPageReqGlobalReqCode("REFRESH"));

      /* Delete the top most entry from array */
      if (state.client.respCallStack.length > 1)
        store.dispatch(
          setRespCallStack(state.client.respCallStack.slice(0, -1))
        );

      resolve(prepareAndSendPageReq(true));
    } else {
      resolve("");
    }
  });
};

// export const fetchStartUpConfigs = () => {
//   return new Promise((resolve, reject) => {
//     fetch("./startup.json")
//       .then((response) => response.json())
//       .then(async (startupConfigs) => {
//         resolve(store.dispatch(setStartupConfigs(startupConfigs)));
//       });
//   });
// };

export const establishSession = () => {
  return new Promise(async (resolve, reject) => {
    var state = store.getState();

    if (!sessionStorage.getItem("sessionRetryCount")) {
      sessionStorage.setItem("sessionRetryCount", "0");
      sessionStorage.setItem("keepAliveTimer", `${Date.now()}`);
    }

    // var startupConfigs = state.appBar.startupConfigs
    //   ? state.appBar.startupConfigs
    //   : undefined;

    var count = parseInt(sessionStorage.getItem("sessionRetryCount") || "0");

    if (count < 3) {
      fetch("./startup.json")
        .then((response) => response.json())
        .then(async (startupConfigs) => {
          store.dispatch(setStartupConfigs(startupConfigs));
          // store.dispatch(setAwaitResponse(true));

          if (
            startupConfigs.defaultCredentials &&
            startupConfigs.defaultCredentials != ""
          ) {
            var response = undefined;
            var url =
              startupConfigs && startupConfigs.deploymentMode === "server"
                ? "../../MDREP" +
                  startupConfigs.sessionPayload.environment +
                  "/MDRUSERV"
                : startupConfigs.apiPath +
                  "MDREP" +
                  startupConfigs.sessionPayload.environment +
                  "/MDRUSERV";

            const bodyParam = startupConfigs
              ? startupConfigs.sessionPayload
              : {};

            let authStr =
              "Basic " +
              Buffer.from(startupConfigs.defaultCredentials, "utf-8").toString(
                "base64"
              );

            // let authStr =
            //   "Bearer " + Buffer.from("expiredToken", "utf-8").toString("base64");

            let axiosConfig = {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: authStr,
                Accept: "application/json",
              },
              timeout: 60000,
            };

            if (startupConfigs && startupConfigs.debugOn)
              console.log(
                "Sending session establishment request: \n",
                bodyParam
              );

            await apis
              .post(url || "", bodyParam, axiosConfig)
              .then((resp: any) => {
                response = resp;

                if (response && response.status === 200) {
                  sessionStorage.setItem("sessionRetryCount", "0");

                  // store.dispatch({
                  //   type: "SET_AWAIT_RESPONSE",
                  //   payload: false,
                  // });

                  if (startupConfigs && startupConfigs.debugOn)
                    console.log(
                      "Session establishment response from server: \n",
                      response
                    );

                  // Uncomment for LOCAL
                  // setCookie(
                  //   "Session_LIC_T85",
                  //   `1-${response.data.jobnumber}`,
                  //   86400 * 30
                  // );

                  store.dispatch(resetPageReq(startupConfigs.initialPageReq));

                  store.dispatch(
                    setAppBarLoginInfo({
                      data: response.data,
                      headers: response.headers,
                    })
                  );

                  resolve(
                    localStorage.setItem(
                      "persist:rootLocal",
                      JSON.stringify(state.appBar)
                    )
                  );
                } else {
                  if (startupConfigs.debugOn) console.log("Response error");

                  sessionStorage.setItem("sessionRetryCount", `${count + 1}`); // Increase session retry count
                }
              })
              .catch((err: any) => {
                if (startupConfigs && startupConfigs.debugOn)
                  console.log("Exception error: ", err);

                if (err.name === "AxiosError") {
                  store.dispatch(
                    setMainContentDialogPopUp({
                      header: "REST API Error",
                      content: {
                        title: {
                          Message:
                            "The REST API did not respond timeously. Please check the HTTP server instance CGI jobs.",
                        },
                        details: {
                          "HTTP Instance":
                            Object.keys(state.appBar.loginInfo.headers).length >
                              0 && state.appBar.loginInfo.headers["x-mdrsrvjob"]
                              ? state.appBar.loginInfo.headers[
                                  "x-mdrsrvjob"
                                ].split("-")[2]
                              : "",
                          "CGI Job No":
                            Object.keys(state.appBar.loginInfo.headers).length >
                              0 && state.appBar.loginInfo.headers["x-mdrsrvjob"]
                              ? state.appBar.loginInfo.headers[
                                  "x-mdrsrvjob"
                                ].split("-")[3]
                              : "",
                        },
                        footer:
                          "RELOAD will reload the application and return you to the first screen",
                      },
                      action: ["RELOAD"],
                    })
                  );
                } else if (err.message.search(/timeout/gi) === 0)
                  store.dispatch(
                    setMainContentDialogPopUp({
                      header: err.name,
                      content: {
                        title: {
                          Message: `${err.message}`,
                        },
                        details: {
                          Recovery:
                            "Please check the Server status or correct the error in startup.json config file and refresh the page",
                        },
                      },
                      action: ["WAIT", "DISMISS"],
                    })
                  );
                else if (err.response && err.response.request)
                  store.dispatch(
                    setMainContentDialogPopUp({
                      header: err.name,
                      content: {
                        title: {
                          Message: `${err.response.status} ${err.response.statusText} - ${err.response.request.responseURL}`,
                        },
                        details: {
                          Recovery:
                            "Please check the Server status or correct the error in startup.json config file and refresh the page",
                        },
                      },
                      action: ["DISMISS"],
                    })
                  );
                else
                  store.dispatch(
                    setMainContentDialogPopUp({
                      header: err.name,
                      content: {
                        title: {
                          Message: `${err.message}`,
                        },
                        details: {
                          Recovery:
                            "Please check the Server status or correct the error in startup.json config file and refresh the page",
                        },
                      },
                      action: ["DISMISS"],
                    })
                  );
              });
          }
        });
    } else {
      console.log(
        "Max. session establishment retries reached, please try after sometime."
      );

      // store.dispatch(
      //   setDialogPopUp({
      //     header: "Error",
      //     content: {
      //       title: `Message: Max. session establishment retries reached, please try after sometime.`,
      //     },
      //     action: "DISMISS",
      //   })
      // );
    }
  });
};

export const resetStore = () => {
  return new Promise<void>((resolve, reject) => {
    if (sessionStorage.getItem("persist:rootSession") !== undefined)
      sessionStorage.removeItem("persist:rootSession");

    if (localStorage.getItem("persist:rootLocal") !== undefined)
      localStorage.removeItem("persist:rootLocal");

    store.dispatch(resetAppBarState());
    store.dispatch(resetSidebarState());
    store.dispatch(resetMainContentState());
    store.dispatch(resetClientState());

    resolve();
  });
};

export const establishSessionAndSendQueryParamsPageReq = () => {
  return new Promise(async (resolve, reject) => {
    var state = store.getState();

    /* Reset redux store */
    Promise.resolve(resetStore()).then(() => {
      /* Establish session with the server which sets a SessionId cookie */
      Promise.resolve(establishSession()).then(async () => {
        /* Send Home Page request with default values set in Redux state */
        resolve(populateQueryParamsRequest());
      });
    });
  });
};

export const establishSessionAndSendInitialPageReq = () => {
  return new Promise(async (resolve, reject) => {
    var state = store.getState();

    /* Reset redux store */
    Promise.resolve(resetStore()).then(() => {
      /* Establish session with the server which sets a SessionId cookie */
      Promise.resolve(establishSession()).then(async () => {
        /* Send Home Page request with default values set in Redux state */
        resolve(sendInitialPageRequest());
      });
    });
  });
};

export const sendInitialPageRequest = () => {
  return new Promise((resolve, reject) => {
    var state = store.getState();
    /* If already logged in from another page */
    if (
      Object.keys(state.client.pageReq).length === 0 &&
      localStorage.getItem("persist:rootLocal") != null
    ) {
      store.dispatch(
        resetPageReq(
          JSON.parse(
            JSON.parse(localStorage.getItem("persist:rootLocal")!)
              .startupConfigs
          ).initialPageReq
        )
      );

      store.dispatch(
        setStartupConfigs(
          JSON.parse(
            JSON.parse(localStorage.getItem("persist:rootLocal")!)
              .startupConfigs
          )
        )
      );

      store.dispatch(
        setAppBarLoginInfo(
          JSON.parse(
            JSON.parse(localStorage.getItem("persist:rootLocal")!).loginInfo
          )
        )
      );
    }

    resolve(prepareAndSendPageReq());
  });
};

export const fetchDdlist = (ddlists: IDdlField[]) => {
  return new Promise((resolve, reject) => {
    /* Reset client state */
    store.dispatch(
      resetPageReq({
        global: {},
      } as IPageRequest)
    );

    /* Set function */
    store.dispatch(setPageReqGlobalFunc(""));

    /* Set getOptions */
    store.dispatch(setPageReqGlobalGetOptions(""));

    /* Set ddl lists */
    store.dispatch(setPageReqGlobalDdlists("true"));
    store.dispatch(setPageReqDdlists(ddlists));

    resolve(prepareAndSendPageReq());
  });
};

export const sendLogoffRequest = () => {
  return new Promise<void>(async (resolve, reject) => {
    const state = store.getState();

    var startupConfigs: IStartupConfig = state.appBar.startupConfigs
      ? state.appBar.startupConfigs
      : ({} as IStartupConfig);

    var url =
      startupConfigs && startupConfigs.deploymentMode === "server"
        ? "../../MDREP" +
          startupConfigs.sessionPayload.environment +
          "/MDWSOPEN"
        : startupConfigs.apiPath +
          "MDREP" +
          startupConfigs.sessionPayload.environment +
          "/MDWSOPEN";

    let bodyParam = { action: "end" };
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "X-MDREP-ACTION": "end",
        "X-MDREP-WAIT": state.appBar.startupConfigs.maxwait,
        "X-MDREP-QUEUE-NUMBER": state.appBar.loginInfo.data.jobnumber,
        "X-MDREP-QUEUE-LIBRARY": state.appBar.loginInfo.data.dataqlib,
        "X-MDREP-SESSION-ID":
          state.appBar.loginInfo.headers["x-mdrep-session-id"],
      },
      timeout: 60000,
    };

    /* Reset request params */
    console.log("Sending Logoff Request");

    await apis
      .post(url || "", bodyParam, axiosConfig)
      .then((resp) => {
        console.log("Received Logoff Response: ", resp);

        /* Fetch data from server */
        // var response: IPageResponse = resp.data;

        window.scrollTo(0, 0);

        setCookie(
          `Session_${state.appBar.loginInfo.data.version}_${state.appBar.loginInfo.data.environment}`,
          "",
          0
        ); // Delete cookie

        sessionStorage.removeItem("keepAliveTimer"); // Deleting timer
        localStorage.removeItem("persist:rootLocal"); // Delete session info from localStorage
        store.dispatch(setAppBarLoginInfo({} as ILoginInformation));

        /* Set main content fields */
        store.dispatch(
          setMainContentFieldList([
            {
              name: "BACKTOLOGIN",
              posRow: 1,
              posCol: 1,
              type: "string",
              length: 35,
              clickable: "true",
              visible: "true",
              value: "Back To User Login",
            },
          ])
        );

        /* Set main content buttons */
        store.dispatch(setMainContentButtonList([]));

        /* Set main content grids */
        store.dispatch(setMainContentGridList([]));

        /* Set main content caption */
        store.dispatch(setMainContentCaption("Log Off"));

        /* Set main content screen */
        store.dispatch(setMainContentScreen("LOGOFF"));

        /* Set main content message list */
        store.dispatch(
          setMainContentMessageList([
            {
              text: "You have successfully logged out of MD License Tool. There is no other active thread.",
              severity: 10,
              async: "false",
            },
          ])
        );

        /* Set main content navList */
        updateNavList("Log Off", "LOGOFF");

        /* Set sidebar optionsList */
        store.dispatch(setSidebarOptionsList([]));

        resolve();
      })
      .catch((err: any) => {
        if (startupConfigs && startupConfigs.debugOn)
          console.log("Exception error: ", err);

        if (err.name === "AxiosError") {
          store.dispatch(
            setMainContentDialogPopUp({
              header: "REST API Error",
              content: {
                title: {
                  Message:
                    "The REST API did not respond timeously. Please check the HTTP server instance CGI jobs.",
                },
                details: {
                  "HTTP Instance":
                    Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                    state.appBar.loginInfo.headers["x-mdrsrvjob"]
                      ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                          "-"
                        )[2]
                      : "",
                  "CGI Job No":
                    Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                    state.appBar.loginInfo.headers["x-mdrsrvjob"]
                      ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                          "-"
                        )[3]
                      : "",
                },
                footer:
                  "RELOAD will reload the application and return you to the first screen",
              },
              action: ["RELOAD"],
            })
          );
        } else if (err.message.search(/timeout/gi) === 0)
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.message}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["WAIT", "DISMISS"],
            })
          );
        else if (err.response && err.response.request)
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.response.status} ${err.response.statusText} - ${err.response.request.responseURL}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["DISMISS"],
            })
          );
        else
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.message}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["DISMISS"],
            })
          );
      });
  });
};

export const sendKeepAliveRequest = () => {
  return new Promise<void>(async (resolve, reject) => {
    const state = store.getState();

    var startupConfigs: IStartupConfig = state.appBar.startupConfigs
      ? state.appBar.startupConfigs
      : ({} as IStartupConfig);

    var url =
      startupConfigs && startupConfigs.deploymentMode === "server"
        ? "../../MDREP" +
          startupConfigs.sessionPayload.environment +
          "/MDWSOPEN"
        : startupConfigs.apiPath +
          "MDREP" +
          startupConfigs.sessionPayload.environment +
          "/MDWSOPEN";

    let bodyParam = { action: "keep-alive" };
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "X-MDREP-ACTION": "messages",
        "X-MDREP-WAIT": state.appBar.startupConfigs.maxwait,
        "X-MDREP-QUEUE-NUMBER": state.appBar.loginInfo.data.jobnumber,
        "X-MDREP-QUEUE-LIBRARY": state.appBar.loginInfo.data.dataqlib,
        "X-MDREP-RECKEY": "REQ",
        "X-MDREP-SESSION-ID":
          state.appBar.loginInfo.headers["x-mdrep-session-id"],
      },
      timeout: 60000,
    };

    /* Reset request params */
    console.log("Sending Keep Alive Request");

    await apis
      .post(url || "", bodyParam, axiosConfig)
      .then((resp) => {
        console.log("Received Keep Alive Response: ", resp);

        /* If no error means job exists */
        if (!resp.data.err_Severity) {
          sessionStorage.setItem("keepAliveTimer", `${Date.now()}`); // Resetting timer
          setCookie(
            `Session_${state.appBar.loginInfo.data.version}_${state.appBar.loginInfo.data.environment}`,
            getCookie(
              `Session_${state.appBar.loginInfo.data.version}_${state.appBar.loginInfo.data.environment}`
            ),
            120
          ); // Reset cookie to 2 hrs from now
        } else {
          setCookie(
            `Session_${state.appBar.loginInfo.data.version}_${state.appBar.loginInfo.data.environment}`,
            "",
            0
          ); // Delete cookie as job is deleted on server
        }

        resolve();
      })
      .catch((err: any) => {
        if (startupConfigs && startupConfigs.debugOn)
          console.log("Exception error: ", err);

        if (err.name === "AxiosError") {
          store.dispatch(
            setMainContentDialogPopUp({
              header: "REST API Error",
              content: {
                title: {
                  Message:
                    "The REST API did not respond timeously. Please check the HTTP server instance CGI jobs.",
                },
                details: {
                  "HTTP Instance":
                    Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                    state.appBar.loginInfo.headers["x-mdrsrvjob"]
                      ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                          "-"
                        )[2]
                      : "",
                  "CGI Job No":
                    Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                    state.appBar.loginInfo.headers["x-mdrsrvjob"]
                      ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                          "-"
                        )[3]
                      : "",
                },
                footer:
                  "RELOAD will reload the application and return you to the first screen",
              },
              action: ["RELOAD"],
            })
          );
        } else if (err.message.search(/timeout/gi) === 0)
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.message}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["WAIT", "DISMISS"],
            })
          );
        else if (err.response && err.response.request)
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.response.status} ${err.response.statusText} - ${err.response.request.responseURL}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["DISMISS"],
            })
          );
        else
          store.dispatch(
            setMainContentDialogPopUp({
              header: err.name,
              content: {
                title: {
                  Message: `${err.message}`,
                },
                details: {
                  Recovery:
                    "Please check the Server status or correct the error in startup.json config file and refresh the page",
                },
              },
              action: ["DISMISS"],
            })
          );
      });
  });
};

export const backToLogin = () => {
  return new Promise((resolve, reject) => {
    const state = store.getState();

    if (
      localStorage.getItem("persist:rootLocal") != null &&
      Object.keys(
        JSON.parse(
          JSON.parse(localStorage.getItem("persist:rootLocal")!).loginInfo
        )
      ).length != 0
    ) {
      /* Reset redux store */
      store.dispatch(resetSidebarState());
      store.dispatch(resetMainContentState());
      store.dispatch(resetClientState());

      /* Send initial page request */
      sendInitialPageRequest();
    } else {
      reloadApplication();
    }
  });
};

export const reloadApplication = () => {
  return new Promise((resolve, reject) => {
    const state = store.getState();

    if (
      Object.keys(state.appBar.loginInfo).length &&
      Object.keys(state.appBar.loginInfo.data).length &&
      getCookie(
        `Session_${state.appBar.loginInfo.data.version}_${state.appBar.loginInfo.data.environment}`
      )
    ) {
      setCookie(
        `Session_${state.appBar.loginInfo.data.version}_${state.appBar.loginInfo.data.environment}`,
        "",
        0
      ); // Delete cookie
    }

    if (state) {
      /* Delete sessionStorage items */
      sessionStorage.removeItem("persist:rootSession");
      localStorage.removeItem("persist:rootLocal");
      sessionStorage.removeItem("keepAliveTimer");
      sessionStorage.removeItem("sessionRetryCount");
    }

    window.location.reload();

    /* Reset redux store */
    resetStore();
  });
};

export const prepareAndSendPageReq = (
  isBackRequest?: boolean,
  idx?: number,
  isWaitRequest?: boolean
) => {
  return new Promise(async (resolve, reject) => {
    const state = store.getState();

    var startupConfigs: IStartupConfig = state.appBar.startupConfigs
      ? state.appBar.startupConfigs
      : ({} as IStartupConfig);

    if (
      !getCookie(
        `Session_${state.appBar.loginInfo.data.version}_${state.appBar.loginInfo.data.environment}`
      ) &&
      state.client.pageResp.global.screen !== "LOGOFF"
    ) {
      reloadApplication();
    } else {
      var url =
        startupConfigs && startupConfigs.deploymentMode === "server"
          ? "../../MDREP" +
            startupConfigs.sessionPayload.environment +
            "/MDWSOPEN"
          : startupConfigs.apiPath +
            "MDREP" +
            startupConfigs.sessionPayload.environment +
            "/MDWSOPEN";

      let bodyParam;
      let axiosConfig;

      if (isWaitRequest) {
        bodyParam = undefined;
        axiosConfig = {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "X-MDREP-ACTION": "response",
            "X-MDREP-WAIT": state.appBar.startupConfigs.maxwait,
            "X-MDREP-QUEUE-NUMBER": state.appBar.loginInfo.data.jobnumber,
            "X-MDREP-QUEUE-LIBRARY": state.appBar.loginInfo.data.dataqlib,
            "X-MDREP-RECKEY": "REQ",
            "X-MDREP-SESSION-ID":
              state.appBar.loginInfo.headers["x-mdrep-session-id"],
          },
          timeout: 60000,
        };
      } else {
        bodyParam = state.client.pageReq;
        axiosConfig = {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "X-MDREP-ACTION": "request/response",
            "X-MDREP-WAIT": state.appBar.startupConfigs.maxwait,
            "X-MDREP-QUEUE-NUMBER": state.appBar.loginInfo.data.jobnumber,
            "X-MDREP-QUEUE-LIBRARY": state.appBar.loginInfo.data.dataqlib,
            "X-MDREP-RECKEY": "REQ",
            "X-MDREP-SESSION-ID":
              state.appBar.loginInfo.headers["x-mdrep-session-id"],
          },
          timeout: 60000,
        };
      }

      /* Reset Keep alive timer on every request */
      sessionStorage.setItem("keepAliveTimer", `${Date.now()}`);

      console.log("Sending Request:", state.client.pageReq);

      window.history.pushState(state, "", window.location.href);

      await apis
        .post(url || "", bodyParam, axiosConfig)
        .then((resp) => {
          /* Fetch data from server */
          var response: IPageResponse = resp.data;

          if (!response.messages) {
            window.myGlobalVar.pendingChanges = {
              status: false,
              items: [],
              showWarning: false,
            };

            window.myGlobalVar.saveBackClick = {
              button: {} as IField,
              caption: "",
            };
          }

          /* Update navigation list */
          if (isBackRequest && idx) updateNavList("", "", idx);
          if (isBackRequest) updateNavList("", "");

          if (
            response.err_Message &&
            response.err_Message.search(/timeout/gi) === 0
          ) {
            console.log("Received Error Response: ", response);

            store.dispatch(
              setMainContentDialogPopUp({
                header: "Error",
                content: {
                  details: { Message: response.err_Message },
                },
                action: ["WAIT", "RELOAD"],
              })
            );
          } else if (response.err_Message) {
            console.log("Received Error Response: ", response);

            store.dispatch(
              setMainContentDialogPopUp({
                header: "Error",
                content: {
                  details: { Message: response.err_Message },
                },
                action: ["RELOAD"],
              })
            );
          } else if (response.global && response.global.nextFunction) {
            /* If Response has NEXT params then compose new request and send it to the server */
            console.log("Received Next Response: ", response);

            /* Push in resp call stack */
            if (
              state.client.pageReq.global.requestCode === undefined ||
              (state.client.pageReq.global.requestCode !== undefined &&
                state.client.pageReq.global.requestCode !== "*BACK" &&
                state.client.pageReq.global.requestCode !== "BACK")
            ) {
              var respCallStack = state.client.respCallStack.slice();

              if (
                respCallStack.find(
                  (callStack) => callStack.function === response.global.function
                ) === undefined &&
                response.global.function !== ""
              ) {
                respCallStack.push({
                  function: response.global.function || "",
                  action: response.global.action || "",
                  thread: response.global.thread || "",
                });

                store.dispatch(setRespCallStack(respCallStack));
              }
            }

            /* Reset request params */
            store.dispatch(
              resetPageReq({
                global: {},
              } as IPageRequest)
            );

            if (response.global.nextFunction === "*BACK")
              resolve(
                populateBackClickRequestParams(response.global.nextFunction)
              );
            else {
              store.dispatch(
                setPageReqGlobalFunc(response.global.nextFunction || "")
              );

              store.dispatch(
                setPageReqGlobalAction(response.global.nextAction || "")
              );

              store.dispatch(
                setPageReqGlobalCaller(response.global.function || "")
              );

              if (response.global.nextKeys) {
                store.dispatch(setPageReqGlobalKeys("true"));

                /* Fetching values of keys from the response/maincontent lists */
                var keys = JSON.parse(
                  JSON.stringify(response.global.nextKeys)
                ).map((key: IKey) => {
                  /* If it is a Field */
                  if (key.value.split(".")[0] === "F")
                    key.value =
                      response.fields &&
                      response.fields?.find((fld) => fld.name === key.name) !==
                        undefined
                        ? response.fields.find((fld) => fld.name === key.name)!
                            .value
                        : state.mainContent.fieldList.find(
                            (fld) => fld.name === key.name
                          )?.value || "";

                  return {
                    name: key.name,
                    value: key.value,
                  };
                });

                store.dispatch(setPageReqKeys(keys));
              }

              /* Set thread */
              // store.dispatch(
              //   setPageReqGlobalThread(
              //     state.client.pageResp.global.thread || ""
              //   )
              // );

              /* Set screen */
              store.dispatch(
                setPageReqGlobalScreen(state.client.pageResp.global.screen)
              );

              /* Set getOptions */
              store.dispatch(setPageReqGlobalGetOptions("true"));

              resolve(prepareAndSendPageReq());
            }
          } else {
            if (response.global && response.global.ddlists === "true") {
              console.log("Received DDL Response: ", response);

              resolve(
                store.dispatch(setMainContentDdlist(response.ddlists || []))
              );
            } else {
              console.log("Received Response: ", response);

              /* Scroll to top for new page */
              if (state.mainContent.screen !== response.global.screen)
                window.scrollTo(0, 0);

              /* Push in resp call stack */
              if (
                state.client.pageReq.global.requestCode === undefined ||
                (state.client.pageReq.global.requestCode !== undefined &&
                  state.client.pageReq.global.requestCode !== "*BACK" &&
                  state.client.pageReq.global.requestCode !== "BACK")
              ) {
                var respCallStack = state.client.respCallStack.slice();

                if (
                  respCallStack.find(
                    (callStack) =>
                      callStack.function === response.global.function
                  ) === undefined &&
                  response.global.function !== ""
                ) {
                  respCallStack.push({
                    function: response.global.function || "",
                    action: response.global.action || "",
                    thread: response.global.thread || "",
                  });

                  store.dispatch(setRespCallStack(respCallStack));
                }
              }

              /* Set main content fields */
              store.dispatch(setMainContentFieldList(response.fields || []));

              /* Set main content buttons */
              store.dispatch(setMainContentButtonList(response.buttons || []));

              /* Set main content grids */
              store.dispatch(setMainContentGridList(response.grids || []));

              /* Set main content message list */
              store.dispatch(
                setMainContentMessageList(response.messages || [])
              );

              /* Set main content caption */
              store.dispatch(
                setMainContentCaption(response.global.caption || "")
              );

              /* Set main content screen */
              store.dispatch(setMainContentScreen(response.global.screen));

              /* Set main content navList */
              updateNavList(
                response.global.caption || "",
                response.global.screen
              );

              /* Set sidebar optionsList */
              store.dispatch(setSidebarOptionsList(response.options || []));

              /* Check fields for file download */
              if (
                response.fields?.find(
                  (fld) =>
                    (fld.name === "FILPTH" || fld.name === "XLSPTH") &&
                    fld.value !== ""
                ) !== undefined
              ) {
                var fld = response.fields.find(
                  (fld) =>
                    (fld.name === "FILPTH" || fld.name === "XLSPTH") &&
                    fld.value !== ""
                )!;

                downloadFileFromServer(fld.value);
              }

              /* Compose ddl fetch list for fields */
              var ddlListToFetch: { field: string }[] = [];

              if (
                response.fields &&
                response.fields.find((fld) => fld.type === "ddl") !== undefined
              ) {
                ddlListToFetch = response.fields
                  .filter((fld: IField) => {
                    if (
                      fld.type === "ddl" &&
                      state.mainContent.ddlist.find(
                        (ddl) => ddl.name === fld.name
                      ) === undefined
                    )
                      return { field: fld.name };
                  })
                  .map((fld) => ({ field: fld.name }));
              }

              /* Compose ddl fetch list for grid fields */
              if (
                response.grids &&
                response.grids.find(
                  (grid) =>
                    grid.columns &&
                    grid.columns.find((col) => col.type === "ddl")
                )
              ) {
                response.grids.forEach((grid) => {
                  grid.columns.forEach((col) => {
                    if (
                      col.type === "ddl" &&
                      state.mainContent.ddlist.find(
                        (ddl) => ddl.name === col.name
                      ) === undefined
                    )
                      ddlListToFetch.push({ field: col.name });
                  });
                });
              }

              /* Send DDL Fetch request */
              if (ddlListToFetch.length) fetchDdlist(ddlListToFetch);

              /* Set client page response */
              resolve(store.dispatch(setPageResp(response)));
            }
          }
        })

        .catch((err: any) => {
          if (startupConfigs && startupConfigs.debugOn)
            console.log("Exception error: ", err);

          if (err.name === "AxiosError") {
            store.dispatch(
              setMainContentDialogPopUp({
                header: "REST API Error",
                content: {
                  title: {
                    Message:
                      "The REST API did not respond timeously. Please check the HTTP server instance CGI jobs.",
                  },
                  details: {
                    "HTTP Instance":
                      Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                      state.appBar.loginInfo.headers["x-mdrsrvjob"]
                        ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                            "-"
                          )[2]
                        : "",
                    "CGI Job No":
                      Object.keys(state.appBar.loginInfo.headers).length > 0 &&
                      state.appBar.loginInfo.headers["x-mdrsrvjob"]
                        ? state.appBar.loginInfo.headers["x-mdrsrvjob"].split(
                            "-"
                          )[3]
                        : "",
                  },
                  footer:
                    "RELOAD will reload the application and return you to the first screen",
                },
                action: ["RELOAD"],
              })
            );
          } else if (err.message.search(/timeout/gi) === 0)
            store.dispatch(
              setMainContentDialogPopUp({
                header: err.name,
                content: {
                  title: {
                    Message: `${err.message}`,
                  },
                  details: {
                    Recovery:
                      "Please check the Server status or correct the error in startup.json config file and refresh the page",
                  },
                },
                action: ["WAIT", "DISMISS"],
              })
            );
          else if (err.response && err.response.request)
            store.dispatch(
              setMainContentDialogPopUp({
                header: err.name,
                content: {
                  title: {
                    Message: `${err.response.status} ${err.response.statusText} - ${err.response.request.responseURL}`,
                  },
                  details: {
                    Recovery:
                      "Please check the Server status or correct the error in startup.json config file and refresh the page",
                  },
                },
                action: ["DISMISS"],
              })
            );
          else
            store.dispatch(
              setMainContentDialogPopUp({
                header: err.name,
                content: {
                  title: {
                    Message: `${err.message}`,
                  },
                  details: {
                    Recovery:
                      "Please check the Server status or correct the error in startup.json config file and refresh the page",
                  },
                },
                action: ["DISMISS"],
              })
            );
        });
    }
  });
};
